export enum MissionCategoryEnum {
  GENERAL = 'GENERAL',
  ETH = 'ETH',
  STABLECOIN = 'STABLECOIN',
}
